export default "__VITE_ASSET__UiPEnVaZ__"